module.exports = __webpack_public_path__ + "media/onboarding_upsell_coffee_table.5b2a5724.png";